(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("@splat/constant"), require("@splat/global-i18n"), require("csx"), require("element-ui"), require("typestyle"));
	else if(typeof define === 'function' && define.amd)
		define([, , , , ], factory);
	else if(typeof exports === 'object')
		exports["inject-flash"] = factory(require("@splat/constant"), require("@splat/global-i18n"), require("csx"), require("element-ui"), require("typestyle"));
	else
		root["inject-flash"] = factory(root[undefined], root[undefined], root[undefined], root[undefined], root[undefined]);
})(self, function(__WEBPACK_EXTERNAL_MODULE__splat_constant__, __WEBPACK_EXTERNAL_MODULE__splat_global_i18n__, __WEBPACK_EXTERNAL_MODULE_csx__, __WEBPACK_EXTERNAL_MODULE_element_ui__, __WEBPACK_EXTERNAL_MODULE_typestyle__) {
return /******/ (function() { // webpackBootstrap
/******/ 	"use strict";
/******/ 	var __webpack_modules__ = ({

/***/ "@splat/constant":
/*!*****************************************************************************!*\
  !*** external {"commonjs":"@splat/constant","commonjs2":"@splat/constant"} ***!
  \*****************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_constant__;

/***/ }),

/***/ "@splat/global-i18n":
/*!***********************************************************************************!*\
  !*** external {"commonjs":"@splat/global-i18n","commonjs2":"@splat/global-i18n"} ***!
  \***********************************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE__splat_global_i18n__;

/***/ }),

/***/ "csx":
/*!*****************************************************!*\
  !*** external {"commonjs":"csx","commonjs2":"csx"} ***!
  \*****************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_csx__;

/***/ }),

/***/ "element-ui":
/*!*******************************************************************!*\
  !*** external {"commonjs":"element-ui","commonjs2":"element-ui"} ***!
  \*******************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_element_ui__;

/***/ }),

/***/ "typestyle":
/*!*****************************************************************!*\
  !*** external {"commonjs":"typestyle","commonjs2":"typestyle"} ***!
  \*****************************************************************/
/***/ (function(module) {

module.exports = __WEBPACK_EXTERNAL_MODULE_typestyle__;

/***/ }),

/***/ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js":
/*!***************************************************************************************************************************************!*\
  !*** ../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js ***!
  \***************************************************************************************************************************************/
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ _defineProperty; }
/* harmony export */ });
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry need to be wrapped in an IIFE because it need to be isolated against other modules in the chunk.
!function() {
/*!***********************!*\
  !*** ./src/index.tsx ***!
  \***********************/
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "StatusType": function() { return /* binding */ StatusType; },
/* harmony export */   "_injectFlash": function() { return /* binding */ _injectFlash; },
/* harmony export */   "$_error": function() { return /* binding */ $_error; },
/* harmony export */   "$_success": function() { return /* binding */ $_success; },
/* harmony export */   "$_warning": function() { return /* binding */ $_warning; },
/* harmony export */   "$_info": function() { return /* binding */ $_info; },
/* harmony export */   "injectFlash": function() { return /* binding */ injectFlash; },
/* harmony export */   "$error": function() { return /* binding */ $error; },
/* harmony export */   "$success": function() { return /* binding */ $success; },
/* harmony export */   "$warning": function() { return /* binding */ $warning; },
/* harmony export */   "$info": function() { return /* binding */ $info; },
/* harmony export */   "confirm": function() { return /* binding */ confirm; }
/* harmony export */ });
/* harmony import */ var _babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! @babel/runtime/helpers/defineProperty */ "../../.yarn/cache/@babel-runtime-npm-7.17.2-ec60bc114d-a48702d271.zip/node_modules/@babel/runtime/helpers/esm/defineProperty.js");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! @splat/constant */ "@splat/constant");
/* harmony import */ var _splat_constant__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_splat_constant__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _splat_global_i18n__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(/*! @splat/global-i18n */ "@splat/global-i18n");
/* harmony import */ var _splat_global_i18n__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_splat_global_i18n__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(/*! csx */ "csx");
/* harmony import */ var csx__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(csx__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var element_ui__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(/*! element-ui */ "element-ui");
/* harmony import */ var element_ui__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(element_ui__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(/*! typestyle */ "typestyle");
/* harmony import */ var typestyle__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(typestyle__WEBPACK_IMPORTED_MODULE_5__);


var _elMessageBoxCe;






var StatusType;

(function (StatusType) {
  StatusType["success"] = "success";
  StatusType["warning"] = "warning";
  StatusType["error"] = "error";
  StatusType["info"] = "info";
})(StatusType || (StatusType = {}));

var defaultDuration = 2000;
var _injectFlash = function _injectFlash(message, type, duration) {
  (0,element_ui__WEBPACK_IMPORTED_MODULE_4__.Message)({
    message: message,
    type: type,
    duration: (0,_splat_constant__WEBPACK_IMPORTED_MODULE_1__.isUndef)(duration) ? defaultDuration : duration
  });
};
var $_error = function $_error(content, duration) {
  return _injectFlash(content, StatusType.error, duration);
};
var $_success = function $_success(content, duration) {
  return _injectFlash(content, StatusType.success, duration);
};
var $_warning = function $_warning(content, duration) {
  return _injectFlash(content, StatusType.warning, duration);
};
var $_info = function $_info(content, duration) {
  return _injectFlash(content, StatusType.info, duration);
};
var injectFlash = (0,_splat_constant__WEBPACK_IMPORTED_MODULE_1__.throttle)(_injectFlash, 200);
var $error = function $error(content, duration) {
  return injectFlash(content, StatusType.error, duration);
};
var $success = function $success(content, duration) {
  return injectFlash(content, StatusType.success, duration);
};
var $warning = function $warning(content, duration) {
  return injectFlash(content, StatusType.warning, duration);
};
var $info = function $info(content, duration) {
  return injectFlash(content, StatusType.info, duration);
};
var confirmMessageBoxHackClassName = (0,typestyle__WEBPACK_IMPORTED_MODULE_5__.style)({
  $nest: {
    '&.el-message-box': {
      width: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(432)
    },
    '&.el-message-box--center .el-message-box__title': (_elMessageBoxCe = {
      WebkitBoxAlign: 'unset',
      alignItems: 'unset',
      WebkitBoxPack: 'unset',
      justifyContent: 'unset'
    }, (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_elMessageBoxCe, '-ms-flex-align', 'unset'), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_elMessageBoxCe, '-ms-flex-pack', 'unset'), (0,_babel_runtime_helpers_defineProperty__WEBPACK_IMPORTED_MODULE_0__["default"])(_elMessageBoxCe, "marginLeft", (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(15)), _elMessageBoxCe),
    '&.el-message-box--center .el-message-box__header': {
      paddingTop: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(32)
    },
    '&.el-message-box--center .el-message-box__btns': {
      textAlign: 'right',
      padding: (0,csx__WEBPACK_IMPORTED_MODULE_3__.padding)(20, 32, 0, 15)
    },
    '&.el-message-box--center .el-message-box__content': {
      textAlign: 'unset',
      marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(40),
      paddingTop: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(0)
    },
    '&.el-message-box--center .el-message-box__status': {
      paddingRight: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(12),
      transform: (0,csx__WEBPACK_IMPORTED_MODULE_3__.translateY)((0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(-4))
    },
    '&.el-message-box--center .el-icon-warning': {
      marginTop: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(1)
    },
    '&.el-message-box--center .el-message-box__status::before': {
      color: '#FAAD14'
    },
    '&.el-message-box--center .sl-custom-button__inject-flash__cancel': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.normalBackground.toString(),
      borderColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.normalBackground.toString(),
      padding: (0,csx__WEBPACK_IMPORTED_MODULE_3__.padding)(9, 17),
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.normalFont.toString(),
      fontWeight: 400
    },
    '&.el-message-box--center .sl-custom-button__inject-flash__cancel:hover': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.normalFont.toString(),
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.normalHighlightBackground.toString()
    },
    '&.el-message-box--center .el-button--primary': {
      marginLeft: (0,csx__WEBPACK_IMPORTED_MODULE_3__.px)(24),
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.primaryBackground.toString(),
      borderColor: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.primaryBackground.toString(),
      padding: (0,csx__WEBPACK_IMPORTED_MODULE_3__.padding)(9, 17),
      fontWeight: 400
    },
    '&.el-message-box--center .el-button--primary:hover': {
      background: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.primaryHighlightBackground.toString()
    },
    '.el-message-box__headerbtn .el-icon-close': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.ButtonColors.normalFont.toString()
    },
    '&.el-message-box--center .el-message-box__header .el-message-box__headerbtn .el-icon-close:hover': {
      color: _splat_constant__WEBPACK_IMPORTED_MODULE_1__.CommonColors.primaryText.toString()
    }
  }
});
function confirm(text, cancel, ok) {
  return element_ui__WEBPACK_IMPORTED_MODULE_4__.MessageBox.confirm(text, (_splat_global_i18n__WEBPACK_IMPORTED_MODULE_2___default().t.global.injectFlash.confirm.title), {
    center: true,
    type: 'warning',
    cancelButtonClass: 'el-button--small sl-custom-button__inject-flash__cancel',
    confirmButtonClass: 'el-button--small',
    customClass: confirmMessageBoxHackClassName,
    showClose: false,
    cancelButtonText: cancel !== null && cancel !== void 0 ? cancel : (_splat_global_i18n__WEBPACK_IMPORTED_MODULE_2___default().t.global.injectFlash.confirm.cancel),
    confirmButtonText: ok !== null && ok !== void 0 ? ok : (_splat_global_i18n__WEBPACK_IMPORTED_MODULE_2___default().t.global.injectFlash.confirm.confirm)
  }).then(function (d) {
    // TODO: fix type error
    if (d === 'confirm') {
      return Promise.resolve(true);
    }

    return Promise.reject(false);
  });
}
}();
/******/ 	return __webpack_exports__;
/******/ })()
;
});
//# sourceMappingURL=index.js.map